import React, { useState } from 'react';
import { Typography, Stack, Button, TextField, Container } from '@mui/material';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
    } catch (error) {
      setError('Failed to send password reset email');
      console.error('Error sending password reset email:', error);
    }
    setSuccess(true);
  };

  const handleGoBack = () => {
    navigate('/login'); // Navigate back to the login page
  };

  return (
    <Container maxWidth="md">
      <Stack gap={4} sx={{ p: '20px' }}>
        <Typography variant="h3" textAlign="center">
          Forgot Password
        </Typography>

        {success ? (
          <Typography variant="h5" textAlign="center">
            Password reset instructions have been sent to your email.
          </Typography>
        ) : (
          <form onSubmit={handleResetPassword}>
            <Stack direction="column" gap={3}>
              <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {error && <Typography color="error">{error}</Typography>}

              <Button variant="contained" type="submit">
                Reset Password
              </Button>
            </Stack>
          </form>
        )}

        <Button variant="outlined" onClick={handleGoBack}>
          Go back to Login
        </Button>
      </Stack>
    </Container>
  );
};

export  {ForgotPassword};
